import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import { useLang } from '../context/LanguageContext';

const NAV_PATHS = ['/', '/services', '/projects', '/about', '/contact'];

const SERVICES = [
  { to: '/services/sites-web',   labelFr: 'Sites web',           labelEn: 'Websites' },
  { to: '/services/logiciel',    labelFr: 'Logiciel sur mesure', labelEn: 'Custom software' },
  { to: '/services/ia',          labelFr: 'Solutions IA',        labelEn: 'AI solutions' },
  { to: '/services/maintenance', labelFr: 'Maintenance',         labelEn: 'Maintenance' },
];

const Footer = () => {
  const { t, lang } = useLang();
  return (
  <footer className={styles.footer}>
    {/* Top glow separator */}
    <div className={styles.separator}>
      <div className={styles.separatorGlow} />
    </div>

    <div className={styles.container}>
      <div className={styles.grid}>

        {/* ── Brand ── */}
        <div className={styles.brand}>
          <Link to="/" className={styles.logoWrap}>
            <img
              src="/logo/axisdev-logo.svg"
              alt="AxisDev"
              className={styles.logo}
            />
          </Link>
          <p className={styles.tagline}>
            {t.footer.tagline.split('\n').map((line, i) => (
              <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
            ))}
          </p>
          <div className={styles.socials}>
            <a
              href="https://github.com/AxisDevCa"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.social}
              aria-label="GitHub"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5c.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34c-.46-1.16-1.11-1.47-1.11-1.47c-.91-.62.07-.6.07-.6c1 .07 1.53 1.03 1.53 1.03c.87 1.52 2.34 1.07 2.91.83c.09-.65.35-1.09.63-1.34c-2.22-.25-4.55-1.11-4.55-4.92c0-1.11.38-2 1.03-2.71c-.1-.25-.45-1.29.1-2.64c0 0 .84-.27 2.75 1.02c.79-.22 1.65-.33 2.5-.33c.85 0 1.71.11 2.5.33c1.91-1.29 2.75-1.02 2.75-1.02c.55 1.35.2 2.39.1 2.64c.65.71 1.03 1.6 1.03 2.71c0 3.82-2.34 4.66-4.57 4.91c.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2z"/>
              </svg>
              GitHub
            </a>

          </div>
        </div>

        {/* ── Navigation ── */}
        <div className={styles.col}>
          <h5 className={styles.colTitle}>Navigation</h5>
          <ul className={styles.linkList}>
            {NAV_PATHS.map((path, i) => (
              <li key={path}>
                <Link to={path} className={styles.link}>
                  <span className={styles.linkDot} />
                  {t.footer.nav[i]}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Services ── */}
        <div className={styles.col}>
          <h5 className={styles.colTitle}>Services</h5>
          <ul className={styles.linkList}>
            {SERVICES.map(({ to, labelFr, labelEn }) => (
              <li key={to}>
                <Link to={to} className={styles.link}>
                  <span className={styles.linkDot} />
                  {lang === 'fr' ? labelFr : labelEn}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Contact ── */}
        <div className={styles.col}>
          <h5 className={styles.colTitle}>Contact</h5>
          <ul className={styles.linkList}>
            <li>
              <a href="mailto:contact@axisdevagency.com" className={styles.link}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                contact@axisdevagency.com
              </a>
            </li>
            <li>
              <span className={styles.infoItem}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                Canada
              </span>
            </li>
          </ul>
        </div>

      </div>

      {/* ── Bottom bar ── */}
      <div className={styles.bottom}>
        <span className={styles.copy}>{t.footer.copy}</span>
        <div className={styles.bottomCenter}>
          <span className={styles.statusDot} />
          <span className={styles.statusText}>{t.footer.status}</span>
        </div>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
